export default __webpack_public_path__ + "static/media/202108251530400009_2_half-min.d520d6d6.jpg";